<tt-page>
    <tt-page-heading></tt-page-heading>
    <tt-charge-test [params]="params"></tt-charge-test>
</tt-page>
